import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, switchMap, take,} from "rxjs/operators";
import {ORGANISER_DASHBOARD} from "src/app/app-routing.module";
import {Category, EventItem, FetchEventByIdRequest} from "@model";
import {CategoriesService, EventService, Features} from "@services";

export const CategoryResolver: ResolveFn<Observable<Category[] | null> |
  Promise<Category[]> | Category[]> = (route: ActivatedRouteSnapshot,
                                       state: RouterStateSnapshot,
                                       categoryService: CategoriesService = inject(CategoriesService),
                                       router: Router = inject(Router)): Observable<Category[] | null> |
  Promise<Category[]> | Category[] => {

  let organiserId: number | undefined = undefined;
  const feature: Features = route.data['feature'];

  if (feature === Features.OrganisersEdit) {
    organiserId = route.queryParams['organiserId']
      ? +route.queryParams['organiserId']
      : undefined;
  }
  return categoryService.findCategoriesList(
    organiserId)
    .pipe(
      take(1),
      mergeMap((res: Category[] | null) => {
        if (res) {
          return of(res);
        } else {
          router.navigate([ORGANISER_DASHBOARD]);
          return EMPTY;
        }
      })
    );
}

export const EventCategoryResolver: ResolveFn<Observable<Category[] | null> |
  Promise<Category[]> | Category[]> =
  (route: ActivatedRouteSnapshot,
   _state: RouterStateSnapshot,
   categoryService: CategoriesService = inject(CategoriesService),
   eventService: EventService = inject(EventService),
   router: Router = inject(Router)): Observable<Category[] | null> |
    Promise<Category[]> | Category[] => {
    let eventId = route.queryParams["eventId"];
    let organiserId = route.queryParams["organiserId"];
    if (!eventId) {
      router.navigate([ORGANISER_DASHBOARD]);
      return EMPTY;
    } else if (organiserId) {
      return categoryService.findCategoriesList(+organiserId, false);
    }else {
      return eventService.findEventByIdProtected(
        new FetchEventByIdRequest(+eventId))
        .pipe(
          switchMap((event: EventItem | null) => {
            if (event) {
              return categoryService.findCategoriesList(
                event.organiserId, false);
            } else {
              return of(null);
            }
          }), mergeMap((category: Category[] | null) => {
            if (category) {
              return of(category);
            } else {
              router.navigate([ORGANISER_DASHBOARD]);
              return EMPTY;
            }
          })
        );
    }
  }

